import apiClient from './apiClient.js';

export const pauseEvent = async (event_id) => {
    const pause_url = '/event/pause';

    try {
        const response = await apiClient.post(pause_url, {
            event_id: event_id,
        });
        return response.data.response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
